import 'lightgallery.js';
import { iconSVG } from '../tools/utils';
import { addClass, removeClass } from '../tools/DOM';


const lightGallery = window.lightGallery;


export const init = () => {
	const elements = [...document.querySelectorAll('.js-gallery')];


	elements.forEach((element) => {
		lightGallery(element, {
			selector: '[data-gallery]',
			prevHtml: iconSVG('angle-l'),
			nextHtml: iconSVG('angle-r'),
		});

		element.addEventListener('onAfterOpen', () => {
			const close = document.querySelector('.lg-close');

			close.innerHTML = iconSVG('close');
		});

		element.addEventListener('onBeforeSlide', () => {
			const caption = document.querySelector('.lg-sub-html');

			addClass(caption, 'is-hidden');
		});

		element.addEventListener('onAfterSlide', () => {
			const caption = document.querySelector('.lg-sub-html');

			removeClass(caption, 'is-hidden');
		});
	});
};
